import { createSlice } from "@reduxjs/toolkit";
import { analyzeMedicalInterraction } from "../../../consultation/redux/thunks/medicalInterractionThunk";

const initialState = {
  loading: false,
  result: null,
  error: null,
};

const medicalInterractionSlice = createSlice({
  name: "medicalInterraction",
  initialState,
  reducers: {
    clearInterractionState: (state) => {
      state.loading = false;
      state.result = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(analyzeMedicalInterraction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(analyzeMedicalInterraction.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(analyzeMedicalInterraction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearInterractionState } =
  medicalInterractionSlice.actions;

export default medicalInterractionSlice.reducer;